module.exports = __webpack_public_path__ + "static/media/yuangong.67abab6b.png";